import { useCallback, useEffect, useState } from "react";
import { API_BASE, apiFetch } from "../api";
import { localToday } from "./taskUtils";

const request = async (path, method = "GET", body) => {
  const res = await apiFetch(`${API_BASE}/tasks${path}`, {
    method,
    headers: { "Content-Type": "application/json" },
    body: body ? JSON.stringify(body) : undefined,
  });
  const data = res.status === 204 ? null : await res.json().catch(() => ({}));
  if (!res.ok) throw new Error((data && data.error) || "Something went wrong.");
  return data;
};

// Shared by the phone and desktop task screens. Every action returns a promise
// that rejects with a readable message, so screens can show it.
export const useTasks = () => {
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const reload = useCallback(
    () =>
      request("")
        .then((list) => {
          setTasks(list);
          setError(false);
        })
        .catch(() => setError(true))
        .finally(() => setLoading(false)),
    []
  );

  useEffect(() => {
    reload();
  }, [reload]);

  const replace = (task) => setTasks((prev) => prev.map((t) => (t.id === task.id ? task : t)));

  return {
    tasks,
    loading,
    error,
    reload,
    details: (id) => request(`/${id}`),
    create: (body) => request("", "POST", body).then((task) => setTasks((prev) => [...prev, task])),
    update: (id, body) => request(`/${id}`, "PATCH", body).then(replace),
    remove: (id) => request(`/${id}`, "DELETE").then(() => setTasks((prev) => prev.filter((t) => t.id !== id))),
    submit: (id, note, photo) => request(`/${id}/submit`, "POST", { note, photo }).then(replace),
    confirm: (id) => request(`/${id}/confirm`, "POST", { today: localToday() }).then(replace),
    reject: (id, note) => request(`/${id}/reject`, "POST", { note }).then(replace),
  };
};
